var x = function(y) {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = function(x) { return function() { return x; }; }
module.exports = __WEBPACK_EXTERNAL_MODULE_ieee754__;